import React, { ReactNode } from 'react'
import { Text, TextProps, Tooltip } from '@chakra-ui/react';

type Props = TextProps & {
  children: ReactNode,

  enableTooltip?: boolean,
}

const CutText = ({ children, enableTooltip = false, ...props }: Props) => {

  if (enableTooltip) {
    return (
      <Tooltip label={children} openDelay={300}>
        <Text as="div" textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap" {...props}>{children}</Text>
      </Tooltip>
    )
  }
  return (
    <Text as="div" textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap" {...props}>{children}</Text>
  )
}

export default CutText;
